<template>
  <div class="landing-page-cover-editor">
    <v-form class="pb-6">
      <div class="inputs pl-6 pt-6">
        <div class="d-flex align-center">
          <v-autocomplete
            v-model="theSection.coverSrc"
            :items="imageOptions"
            item-text="text"
            item-value="value"
            solo
            rounded
            hide-details
            label="URL da Imagem"
            :disabled="!configurations.coverSrc.visible"
            :class="{ 'disable-pointer': !configurations.coverSrc.visible }"
          ></v-autocomplete>

          <v-switch
            v-model="configurations.coverSrc.visible"
            inset
            class="ml-6"
            @change="toggle('coverSrc', $event)"
          ></v-switch>
        </div>

        <div class="d-flex align-center">
          <v-select
            v-model="theSection.dark"
            :items="configurations.dark.options"
            item-text="title"
            item-value="value"
            solo
            rounded
            hide-details
            label="Claridade"
            :disabled="!configurations.dark.visible"
            :class="{ 'disable-pointer': !configurations.dark.visible }"
          ></v-select>
          <v-switch
            v-model="configurations.dark.visible"
            inset
            class="ml-6"
            @change="toggle('dark', $event)"
          ></v-switch>
        </div>

        <div class="d-flex align-center">
          <v-combobox
            v-model="theSection.logoSrc"
            :items="logoOptions"
            item-text="name"
            item-value="value"
            solo
            rounded
            hide-details
            label="URL do Logotipo"
            :disabled="!configurations.logoSrc.visible"
            @input="onChange('logoSrc', $event)"
          ></v-combobox>
          <v-switch
            v-model="configurations.logoSrc.visible"
            inset
            class="ml-6"
            @change="toggle('logoSrc', $event)"
          ></v-switch>
        </div>

        <div class="d-flex align-center">
          <v-text-field
            v-model="theSection.title"
            solo
            rounded
            hide-details
            label="Título"
            maxlength="100"
            :disabled="!configurations.title.visible"
            @input="onChange('title', $event)"
          ></v-text-field>
          <v-switch
            v-model="configurations.title.visible"
            inset
            class="ml-6"
            @change="toggle('title', $event)"
          ></v-switch>
        </div>

        <div class="d-flex align-center">
          <v-text-field
            v-model="theSection.secondText"
            solo
            rounded
            hide-details
            maxlength="200"
            label="Informação"
            :disabled="!configurations.secondText.visible"
            @input="onChange('secondText', $event)"
          ></v-text-field>
          <v-switch
            v-model="configurations.secondText.visible"
            inset
            class="ml-6"
            @change="toggle('secondText', $event)"
          ></v-switch>
        </div>

        <div class="d-flex align-center">
          <v-text-field
            v-model="theSection.thirdText"
            solo
            rounded
            hide-details
            label="Descrição"
            maxlength="500"
            :disabled="!configurations.thirdText.visible"
            @input="onChange('thirdText', $event)"
          ></v-text-field>
          <v-switch
            v-model="configurations.thirdText.visible"
            inset
            class="ml-6"
            @change="toggle('thirdText', $event)"
          ></v-switch>
        </div>

        <div class="d-flex align-center">
          <v-text-field
            v-model="theSection.loginButton.title"
            solo
            rounded
            hide-details
            label="URL do Logotipo"
            :disabled="!configurations.loginButton.title.visible"
            @input="onChange('loginButton.title', $event)"
          ></v-text-field>

          <v-switch
            v-model="configurations.loginButton.title.visible"
            inset
            class="ml-6"
            @change="toggle('loginButton.title', $event)"
          ></v-switch>

        </div>

        <div class="d-flex align-center">
          <v-text-field
            v-model="theSection.loginButton.path"
            solo
            rounded
            hide-details
            label="URL de Acesso"
            :disabled="!configurations.loginButton.path.visible"
            @input="onChange('loginButton.path', $event)"
          ></v-text-field>

          <v-switch
            v-model="configurations.loginButton.path.visible"
            inset
            class="ml-6"
            @change="toggle('loginButton.path', $event)"
          ></v-switch>
        </div>
      </div>

      <div class="d-flex flex-row-reverse pt-6">
        <v-menu
          v-model="menuSave"
          offset-y
          transition="slide-y-transition"
          :close-on-content-click="false"
        >
          <template #activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              color="success"
              rounded
              text
              class="text-capitalize mr-4"
            >Salvar</v-btn
            >

          </template>
          <v-card max-width="800" class="not-margin">
            <v-card-title class="text-h5"> Deseja confirmar essa operação? </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                rounded
                text
                small
                class="py-4"
                @click="menuSave = false"
              >
                Cancelar
              </v-btn>
              <v-btn
                color="error darken-1"
                rounded
                text
                small
                class="py-4"
                @click="save"
              >
                Confirmar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
        <v-menu
          v-model="menuDelete"
          offset-y
          transition="slide-y-transition"
          :close-on-content-click="false"
        >
          <template #activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              color="error"
              rounded
              text
              class="text-capitalize mr-4"
              >Remover</v-btn
            >
          </template>
          <v-card max-width="300">
            <v-card-title class="text-h5"> Tem Certeza? </v-card-title>

            <v-card-text>
              Se você continuar, esta seção será removida da Homepage do sistema.
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                rounded
                text
                small
                class="py-4"
                @click="menuDelete = false"
              >
                Desistir
              </v-btn>
              <v-btn
                color="error darken-1"
                rounded
                text
                small
                class="py-4"
                @click="remove"
              >
                Remover
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </div>
    </v-form>
  </div>
</template>

<script>
import { get as _get, set as _set } from "lodash";

import { Cover } from "components/landing-page/LandingPageCover";

export default {
  name: "LandingPageEditorCoverEditor",
  props: {
    section: {
      type: Cover,
      required: true
    }
  },
  data: () => ({
    menuSave: false,
    menuDelete: false,
    theSection: new Cover(),
    logoOptions: [
      { name: "Logo secretaria para fundo escuro", value: "https://cdn.educacao.pe.gov.br/storage/assets/logo_see_eleitoral_escuro_bc82d3a6e6.png" },
      { name: "Logo secretaria para fundo claro", value: "https://cdn.educacao.pe.gov.br/storage/assets/logo_see_eleitoral_branco_c2003fd940.png" },
      { name: "Logo secretaria em branco", value: "https://cdn.educacao.pe.gov.br/storage/assets/logo_see_eleitoral_escuro_bc82d3a6e6.png" },
    ],
    imageOptions: [
      { name: "Imagem de fundo 1", value: "alfabeto.jpg" },
      { name: "Imagem de fundo 2", value: "bg-01.jpg" },
      { name: "Imagem de fundo 3", value: "bg-02.jpg" },
      { name: "Imagem de fundo 4", value: "bg-03.jpg" },
      { name: "Imagem de fundo 5", value: "bg-04.jpg" },
      { name: "Imagem de fundo 6", value: "bg-05.jpg" },
      { name: "Imagem de fundo 7", value: "bg-06.jpg" },
      { name: "Imagem de fundo 8", value: "bg-07.jpg" },
      { name: "Imagem de fundo 9", value: "bg-08.jpg" },
      { name: "Imagem de fundo 10", value: "bg-09.jpg" },
    ].map(img => ({
      text: img.name,
      value: `/img/${img.value}`
    })),
    configurations: {
      coverSrc: {
        visible: true,
        value: undefined
      },
      logoSrc: {
        visible: true,
        value: undefined
      },
      dark: {
        visible: true,
        value: undefined,
        options: [
          { title: "Escuro", value: true },
          { title: "Claro", value: false }
        ]
      },
      title: {
        visible: true,
        value: undefined
      },
      secondText: {
        visible: true,
        value: undefined
      },
      thirdText: {
        visible: true,
        value: undefined
      },
      loginButton: {
        title: {
          visible: true,
          value: undefined
        },
        path: {
          visible: true,
          value: undefined
        }
      }
    }
  }),
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.theSection = this.section;

      this.confitureItem("logoSrc");
      this.confitureItem("title");
      this.confitureItem("secondText");
      this.confitureItem("thirdText");
      this.confitureItem("loginButton.title");
      this.confitureItem("loginButton.path");
    },
    confitureItem(modelPath) {
      const model = _get(this.theSection, modelPath);
      const configuration = _get(this.configurations, modelPath);

      configuration.visible = typeof model === "string" && model.length > 0;
      configuration.value = model;
    },
    remove() {
      this.$emit("on-remove", this.section);
    },
    save() {
      if (this.hasEmptyVisibleFields()) {
        this.menuSave = false;
        this.$notifyError("Por favor preencha adequadamente as informações solicitadas ou desative os campos vazios");
        return;
      }

      this.$emit("on-save", this.section);
      this.menuSave = false;
    },
    hasEmptyVisibleFields() {
      const configPaths = [
        "coverSrc",
        "logoSrc",
        "dark",
        "title",
        "secondText",
        "thirdText",
        "loginButton.title",
        "loginButton.path"
      ];

      return configPaths.some(path => {
        const config = _get(this.configurations, path);
        const value = _get(this.theSection, path);

        if (config?.visible) {
          if (typeof value === 'boolean') return false;
          return !value || value.toString().trim() === "";
        }

        return false;
      });
    },
    toggle(modelPath, visible) {
      const configuration = _get(this.configurations, modelPath);
      configuration.visible = visible;

      // Se for qualquer propriedade do loginButton (title ou path)
      if (modelPath.startsWith('loginButton.')) {
        // Define os dois caminhos
        const titlePath = 'loginButton.title';
        const pathPath = 'loginButton.path';

        // Atualiza a visibilidade de ambos
        this.configurations.loginButton.title.visible = visible;
        this.configurations.loginButton.path.visible = visible;

        if (visible) {
          // Restaurar valores anteriores, se existirem
          _set(this.theSection, titlePath, this.configurations.loginButton.title.value ?? '');
          _set(this.theSection, pathPath, this.configurations.loginButton.path.value ?? '');
        } else {
          // Limpar os dois campos
          _set(this.theSection, titlePath, undefined);
          _set(this.theSection, pathPath, undefined);
        }

        return;
      }

      // Comportamento padrão para outros campos
      if (visible) {
        _set(this.theSection, modelPath, configuration.value?.value ?? configuration.value);
      } else {
        _set(this.theSection, modelPath, undefined);
      }
    },
    onChange(configPath, value) {
      const realValue = typeof value === 'object' ? value.value : value;

      let limitedValue = realValue;



      if (configPath === 'title' && typeof realValue === 'string') {
        limitedValue = realValue.slice(0, 100);
      }

      if (configPath === 'secondText' && typeof realValue === 'string') {
        limitedValue = realValue.slice(0, 200);
      }

      if (configPath === 'thirdText' && typeof realValue === 'string') {
        limitedValue = realValue.slice(0, 500);
      }


      _set(this.theSection, configPath, limitedValue);
      _set(this.configurations, configPath + ".value", limitedValue);

    }
  }
};
</script>
